import { useWorkingPlatform } from '@repo/platform';
import Head from 'next/head';
import { useRouter } from 'next/router';
import { useEffect, useState } from 'react';

import ErrorPageLayout from '@/components/error/ErrorPageLayout';
import { useExitService } from '@/lib/hooks/use-exit-service';

export default function NotFound() {
  const router = useRouter();
  const { workingPlatformType } = useWorkingPlatform();
  const { exitService } = useExitService();
  const [isRightButton, setIsRightButton] = useState(true);

  useEffect(() => {
    setIsRightButton(workingPlatformType === 'app');
  }, [workingPlatformType]);

  return (
    <>
      <Head>
        <title>비즈넵 | 존재하지 않는 페이지</title>
      </Head>
      <ErrorPageLayout
        title={'404\n페이지를 찾을 수 없습니다'}
        message="죄송합니다. 이 페이지를 사용할 수 없습니다."
        onClick={router.back}
        onClose={exitService}
        isRightButton={isRightButton}
      />
    </>
  );
}
